import React from 'react'

function EmployeeMainTabs({ tabs, activeTab, onChange }) {
  return (
    <div className="contract-income-tabs employee-page-main-tabs">
      <div className="contract-income-tabs-scroll" role="tablist" aria-label="Разделы страницы">
        {tabs.map(({ id, label, count }) => (
          <button
            key={id}
            type="button"
            role="tab"
            id={`employee-main-tab-${id}`}
            className={`contract-income-tab ${activeTab === id ? 'active' : ''}`}
            aria-selected={activeTab === id}
            aria-controls={id}
            onClick={() => onChange(id)}
          >
            {label}
            {count != null && <span className="employee-main-tab-summary" aria-hidden="true">{count}</span>}
          </button>
        ))}
      </div>
    </div>
  )
}

export default EmployeeMainTabs
